// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 2443 ? "about" : chunkId) + "." + {"2443":"e2df23d1","5385":"f9688f52","7569":"c8d031e9","8472":"bae1000c"}[chunkId] + ".css";
};